import { css, Stack, Typography } from '@mui/material';
import { FaceBookIcon, GoogleIcon, IndeedIcon, LinkidinIcon, TwitterIcon } from '../../../../vectors/index';
import { staticFileLocation } from '@server/constants';

function WelcomStepIcons() {
  return (
    <>
      <Typography lineHeight={1.2} fontSize={16} mt={5} color="gray">
        We'll help you customize your post for your specific <br />
        needs, & get your job live on all major job boards so
        <br />
        we can fill that role fast.
      </Typography>
      <Stack
        mt={3}
        mb={4}
        justifyContent="center"
        textAlign="center"
        direction="row"
        spacing={2}
      >
        <GoogleIcon />
        <IndeedIcon />
        <img
          src={`${staticFileLocation}img/logos/glassdoor.png`}
          css={css`
            max-width: 30px;
            height: 30px;
            width: 100%;
            object-fit: contain;
          `}
          alt="GlassDoor"
        />
        <FaceBookIcon />
        <LinkidinIcon />
        <TwitterIcon />
        <img
          src={`${staticFileLocation}img/logos/job-inventory.png`}
          css={css`
            max-width: 40px;
            height: 30px;
            width: 100%;
            object-fit: contain;
          `}
          alt="GlassDoor"
        />
      </Stack>
    </>
  );
}

export default WelcomStepIcons;
